<script lang="ts" setup>
import { UiButtonIcon } from '../ui-button-icon';

interface Props {
  disabled?: boolean;
}

const props = defineProps<Props>();
</script>

<template>
  <div :class="$style.root">
    <UiButtonIcon v-bind="$attrs" variant="tertiary" :disabled="props.disabled">
      <slot />
    </UiButtonIcon>
  </div>
</template>

<style lang="scss" module>
.root {
  padding: 6px;

  & + & {
    border-left: 1px solid #e4e5e8;
  }
}
</style>
